import Avatar from '../ui/Avatar';

/**
 * Item da lista de agentes na sidebar.
 * Exibe avatar, nome interno e role/tipo (Vendas, Suporte, etc.) com estado visual do selecionado.
 *
 * @param {Object} props
 * @param {{ id: string, publicName: string, internalName?: string, teamId?: string }} props.agent
 * @param {boolean} props.isSelected
 * @param {(id: string) => void} props.onSelect
 * @param {Record<string, { name: string }>} [props.teamsMap] - teamId -> { name }
 */
export default function AgentListItem({ agent, isSelected, onSelect, teamsMap = {} }) {
  const roleLabel = agent.teamId ? (teamsMap[agent.teamId?.toUpperCase()]?.name || agent.teamId) : '—';

  return (
    <button
      type="button"
      onClick={() => onSelect(agent.id)}
      className={`w-full flex items-center gap-3 p-4 rounded-2xl transition-all text-left ${
        isSelected ? 'bg-appPrimary text-white shadow-xl' : 'text-appText hover:bg-appSurfaceBorder/20'
      }`}
      aria-pressed={isSelected}
      aria-label={`Selecionar agente ${agent.publicName || agent.internalName}`}
    >
      <Avatar
        label={agent.publicName || agent.internalName}
        size="sm"
        color={isSelected ? 'bg-white' : 'bg-appSurfaceBorder/50'}
        textColor={isSelected ? 'text-black' : 'text-gray-500'}
      />
      <div className="min-w-0 flex-1">
        <p className="text-xs font-bold truncate">{agent.internalName || agent.publicName}</p>
        <p className={`text-[10px] truncate ${isSelected ? 'text-white/70' : 'text-appTextMuted'}`}>
          {roleLabel}
        </p>
      </div>
    </button>
  );
}
